import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EBON_TAB_IN_PROGRESS, EBON_TAB_CONSUMED } from '../../../../constants/ebon';
import './EbonsTabs.scss';

const EbonsTabs = ({ activeTab, onTabChange, i18nPage }) => {
    const isInProgress = activeTab === EBON_TAB_IN_PROGRESS;
    const isConsumed = activeTab === EBON_TAB_CONSUMED;

    const inProgressRef = useRef(null);
    const consumedRef = useRef(null);
    const userInteractedRef = useRef(false);

    useEffect(() => {
        if (!userInteractedRef.current) return;
        if (isInProgress && inProgressRef.current) inProgressRef.current.focus();
        if (isConsumed && consumedRef.current) consumedRef.current.focus();
    }, [activeTab, isInProgress, isConsumed]);

    const switchTab = newTab => {
        userInteractedRef.current = true;
        onTabChange(newTab);
    };

    const handleKeyDown = e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            switchTab(isInProgress ? EBON_TAB_CONSUMED : EBON_TAB_IN_PROGRESS);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            switchTab(isConsumed ? EBON_TAB_IN_PROGRESS : EBON_TAB_CONSUMED);
        } else if (e.key === 'Home') {
            e.preventDefault();
            switchTab(EBON_TAB_IN_PROGRESS);
        } else if (e.key === 'End') {
            e.preventDefault();
            switchTab(EBON_TAB_CONSUMED);
        }
    };

    return (
        <div className="ebons-tabs-container">
            <div className="ebons-tabs-wrapper" role="tablist" aria-label={i18nPage.TABS.LIST_LABEL}>
                <button
                    ref={inProgressRef}
                    role="tab"
                    id="tab-in-progress"
                    aria-controls="tabpanel-in-progress"
                    aria-selected={isInProgress}
                    tabIndex={isInProgress ? 0 : -1}
                    className={`ebons-tab ebon-tab-left ${isInProgress ? 'active' : ''}`}
                    onClick={() => switchTab(EBON_TAB_IN_PROGRESS)}
                    onKeyDown={handleKeyDown}>
                    {i18nPage.TABS.IN_PROGRESS}
                </button>
                <button
                    ref={consumedRef}
                    role="tab"
                    id="tab-consumed"
                    aria-controls="tabpanel-consumed"
                    aria-selected={isConsumed}
                    tabIndex={isConsumed ? 0 : -1}
                    className={`ebons-tab ebon-tab-right ${isConsumed ? 'active' : ''}`}
                    onClick={() => switchTab(EBON_TAB_CONSUMED)}
                    onKeyDown={handleKeyDown}>
                    {i18nPage.TABS.CONSUMED}
                </button>
            </div>
        </div>
    );
};

EbonsTabs.propTypes = {
    activeTab: PropTypes.oneOf([EBON_TAB_IN_PROGRESS, EBON_TAB_CONSUMED]).isRequired,
    onTabChange: PropTypes.func.isRequired,
    i18nPage: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    i18nPage: state.i18n.page.ACCOUNT.EBONS
});

export default connect(mapStateToProps)(EbonsTabs);



// WEBPACK FOOTER //
// ./src/components/pages/account/myebons/EbonsTabs.js